import styled from 'styled-components';

export const InputWrapper = styled.div`
  padding: 20px 0 0;
  &.checkbox-wrapper {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 11px;
    line-height: 100%;
    color: var(--color-text-muted);
    margin-bottom: 20px;
  }
`;
